import React, {  } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Stack,
  Grid,
  useTheme,
} from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { tokens } from "../../theme";

function PdfViewerDialog({ open, handleClose,downloadPdf, pdfUrl,imageUrl ,comment}) {
   
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      {/* <DialogTitle>PDF</DialogTitle> */}
      <DialogContent>
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="PDF Document"
          width="100%"
          height="400px"
          style={{ border: "none" }}
        ></iframe>
      )}

     {imageUrl && (
      //    <Zoom
      //    overlayBgColorEnd="rgba(0, 0, 0, 0.75)" // Adjust background opacity
      //    zoomMargin={10} // Margin between the zoomed image and the window
      //    closeText="Press Esc to close" // Accessible close text
      //    shouldRespectMaxDimension={true} // Maintain image dimension
      //  >
         <img
           src={imageUrl}
           alt="Preview"
           style={{ width: '500px', height: 'auto' }} //, cursor: 'zoom-in'
         />
      //  </Zoom>
      )}

 {comment!==undefined && comment!==null && comment!=="" && (
        <TextField
          margin="dense"
          label="Comment"
          type="text"
          fullWidth
          variant="standard"
          value={comment}
          //onChange={handleCommentChange}
        />
 )}
      </DialogContent>
      <DialogActions>
      <Grid container justifyContent={"flex-end"}>
                  <Stack
                    direction="row"
                    pt={2}
                    spacing={2}
                    justifyContent={'center'}
                  >
                    {/* <CustomButton
                      btnBG={colors.primary[900]}
                      btnColor={colors.grey[100]}
                      btnTxt={'DOWNLOAD'}
                      btnBorder={'1px solid' + colors.primary[800]}
                      onClick={downloadPdf}
                    ></CustomButton> */}

                    <CustomButton
                      btnBG={colors.primary[100]}
                      btnColor={colors.grey[900]}
                      btnTxt={'CLOSE'}
                      btnBorder={'1px solid' + colors.primary[100]}
                      onClick={handleClose}
                    ></CustomButton>

 
                  </Stack>
                  </Grid>
        {/* <Button onClick={handleClose} color="primary">
          Close
        </Button> */}
      </DialogActions>
    </Dialog>
  );
}
export default PdfViewerDialog;
